import React from 'react'

export default function Footer() {
  return (
    <footer className='py-2 text-slate-500 text-xs text-center font-thin font-mono'>
      <p>© dewan masuma nazneen - Jan, 2024</p>
    </footer>
  )
}
